import { DayTemplateModel } from '../../../shared/models/dayTemplate.model';
import { PresenceTemplateRepeatPatternEnum } from '../../../shared/enums/presenceTemplateRepeatPattern.enum';
import i18n from '../../../shared/locales/i18n';
import { DateTimeUtil } from '../../../shared/utils/dateTimeUtil';
import { ref } from 'vue';

export const usePresenceTemplates = () => {
  const t = i18n.t.bind(i18n);
  const isPatternChanged = ref<boolean>(false);
  const getIsRepeating = (repeatPattern: PresenceTemplateRepeatPatternEnum) =>
    repeatPattern !== PresenceTemplateRepeatPatternEnum.NEVER;
  const getRepeatInfoPrefix = (repeatPattern: PresenceTemplateRepeatPatternEnum, repeatFromDate: string): string => {
    switch (repeatPattern) {
      case PresenceTemplateRepeatPatternEnum.WEEKLY:
        return t('label.repeated_weekly');
      case PresenceTemplateRepeatPatternEnum.EVERY_2_WEEKS:
        return getBaseRepeatEveryTwoWeekInfo(repeatFromDate);
      default:
        return '';
    }
  };

  const getBaseRepeatEveryTwoWeekInfo = (repeatFromDate: string) => {
    const isEvenWeek = DateTimeUtil.isEvenWeek(repeatFromDate);
    return isEvenWeek ? t('label.repeated_on_even_weeks') : t('label.repeated_on_odd_weeks');
  };

  const getRepeatingInfoWithStartWeek = (dayTemplate: DayTemplateModel): string => {
    const { repeatPattern, repeatFromDate, byDate } = dayTemplate;
    const startDate = isPatternChanged.value ? byDate : repeatFromDate;
    const baseText = getRepeatInfoPrefix(repeatPattern, startDate);
    if (!baseText) {
      return '';
    }
    const weekNumber = DateTimeUtil.getWeekNumber(startDate);
    const suffix = ` ${t('label.from')} ${t('label.week_number', { number: weekNumber }).toLowerCase()}`;
    return baseText + suffix;
  };

  const getRepeatingInfoWithEndDate = (dayTemplate: DayTemplateModel): string => {
    const { repeatPattern, repeatFromDate, repeatToDate } = dayTemplate;
    const baseText = getRepeatInfoPrefix(repeatPattern, repeatFromDate);
    if (!baseText) {
      return '';
    }
    if (!repeatToDate) {
      return baseText;
    }
    const formattedDate = DateTimeUtil.formatDate(repeatToDate, 'DD-MM-YYYY');
    const endDateSuffix = ` ${t('label.until')} ${formattedDate}`;
    return baseText + endDateSuffix;
  };

  return {
    isPatternChanged,
    getIsRepeating,
    getRepeatingInfoWithStartWeek,
    getRepeatingInfoWithEndDate,
  };
};
